import "./Newsblog.css";
import Modal from "react-bootstrap/Modal";
import {useState, useEffect, memo} from "react";
import {Link} from "react-router-dom";
import OfferImg5 from "../assets/YogaHerzHand.jpeg"

export default function Newsblog() {
    const MyLink = memo((props) => {
        return <Link {...props} />;
    });

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    useEffect(() => {
        setTimeout(() => setShow(true), 5000);
    }, []);

    function onLinkClick() {
        document.getElementById("offer").scrollIntoView({behavior: "smooth"});
        handleClose()
    }

    return (
        <>
            <Modal
                size="md"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Aktuelle Kurse</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="currentOffer">
                        <p>Finde den passenden Yogakurs in deiner Nähe</p>
                        <img alt="flyer popup yoga" src={OfferImg5}
                             style={{maxWidth: '80%', maxHeight: '80%'}}
                        />
                        <p>
                            <br></br>
                            Yogakurse in Landsberg <br/><MyLink to={"yoga_Landsberg"} onClick={onLinkClick}>mehr erfahren</MyLink>
                            <br></br>
                        </p>
                        <p>
                            Lust auf Deine passende Wohlfühlzeit? <br/><MyLink to={"Yoga_Retreats"} onClick={onLinkClick}>Retreats</MyLink>
                            <br></br>
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
